import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import {
  AccountCircleOutlined,
  AnnouncementOutlined,
  EuroOutlined,
  EmailOutlined,
} from '@mui/icons-material'
import { StarBorder, FindInPageOutlined } from '@mui/icons-material'

import { HeaderButtons, useModalContext } from '../../../../ui'
import { ReviewsDialog } from '../reviews/reviews-dialog.component'
import { DocumentsView } from '../documents-view'
import { MailingView } from '../../../mailing'

const EEII_BUTTONS = (navigate, companyData, open) => ({
  APPLICATIONS: {
    id: 'link_applications',
    icon: <AnnouncementOutlined />,
    onClick: () => navigate(`/applications?empresa=${companyData.id}`),
  },
  TARIFFS: {
    id: 'link_tariffs',
    icon: <EuroOutlined />,
    onClick: () => navigate(`/tariffs?empresa_id=${companyData.id}`),
  },
  RATINGS: {
    id: 'ver_valoraciones',
    icon: <StarBorder />,
    onClick: () => {
      open({
        Component: ReviewsDialog,
        data: { companyId: companyData.id, isPrimaryCompany: true },
        type: 'responsive',
        closable: true,
        maxWidth: 'md',
      })
    },
  },
  COLLABORATORS: {
    id: 'link_collaborators',
    icon: <AccountCircleOutlined />,
    onClick: () => navigate(`/collaborators?empresa=${companyData.id}`),
  },
  DOCUMENTS_VIEW: {
    id: 'documents_view',
    icon: <FindInPageOutlined />,
    onClick: () => {
      open({
        Component: DocumentsView,
        data: { company: companyData },
        type: 'responsive',
        closable: true,
        maxWidth: 'sm',
      })
    },
  },
  MAILING_CONFIG: {
    id: 'mailing_config',
    icon: <EmailOutlined />,
    onClick: () => {
      open({
        Component: MailingView,
        data: { preferencias: companyData.preferencias || [] },
        type: 'responsive',
        closable: true,
        maxWidth: 'md',
      })
    },
  },
})

const userButtons = (user) => {
  switch (user.role) {
    case 'gestor_ip':
      return ['DOCUMENTS_VIEW']
    case 'soporte_procesos':
      return ['APPLICATIONS', 'DOCUMENTS_VIEW']
    case 'e_commerce':
      return ['APPLICATIONS', 'TARIFFS', 'RATINGS', 'DOCUMENTS_VIEW', 'MAILING_CONFIG']
    default:
      return ['APPLICATIONS', 'TARIFFS', 'RATINGS', 'DOCUMENTS_VIEW']
  }
}

export const EEIIActionButtons = ({ companyData }) => {
  const navigate = useNavigate()
  const { formatMessage } = useIntl()
  const location = useLocation()
  const user = useSelector((state) => state.global)
  const {
    actions: { open },
  } = useModalContext()
  const buttons = EEII_BUTTONS(navigate, companyData, open)

  // 1. Evaluamos si es prescriptor
  const isPrescriptor = location.pathname.includes('/eepp') || Boolean(companyData?.prescriptor)

  // 2. Filtramos la lista sin reasignar variables const
  const buttonChoice = userButtons(user).filter(
    (key) => !isPrescriptor || key !== 'TARIFFS'
  )
  return (
    <Box mb={1}>
      <HeaderButtons
        iconButtons={buttonChoice.map((index) => {
          return {
            ...buttons[index],
            label: formatMessage({ id: `pages.eeii.headerButtons.${buttons[index].id}.title` }),
          }
        })}
      />
    </Box>
  )
}

export default EEIIActionButtons
